module.exports = __webpack_public_path__ + "static/img/detail_closer-game_02.86a78b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/the-closer-hot-seat-game/detail_closer-game_02.jpg
// module id = 287
// module chunks = 2